export default "__VITE_ASSET__Bnf_N2Hq__"